import { Box } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { Serializer } from "@shared/mirage/helpers/Serializer";
import { WeeklyListsFilter } from "./WeeklyListsFilter";
import WeeklyListsSimpleSearch from "./WeeklyListsSimpleSearch";
import { useWeeklyListsSearchStore } from "@publicPortal/store/store";
import { EntityTableStateStorage } from "@mirage/components/entityTable/EntityTableStateStorage";
import SearchActions from "../SearchActions";
import { PublicPortalRoutingService } from "@publicPortal/services/PublicPortalRoutingService";

export const WeeklyListsSearch = () => {
    const navigate = useNavigate();
    const pp = new PublicPortalRoutingService();
    const filter = useWeeklyListsSearchStore((s) => s.weeklyListsSearch);
    const updateWeeklyListsSearch = useWeeklyListsSearchStore((s) => s.updateWeeklyListsSearch);
    const resetWeeklyListsSearch = useWeeklyListsSearchStore((s) => s.resetWeeklyListsSearch);

    function setFilterModifier(modifier: Partial<WeeklyListsFilter>) {
        updateWeeklyListsSearch(modifier);
    }

    const onClear = () => {
        resetWeeklyListsSearch();
    };

    const onSearchClicked = () => {
        const filterParams = Serializer.toQueryParamsNotEmptyOnly(filter);
        EntityTableStateStorage.clear("weeklyLists");
        navigate(`${pp.SearchRoute("WeeklyLists", filterParams)}`);
    };

    function formActions() {
        return <SearchActions onSubmitHandler={onSearchClicked} onCancelHandler={onClear} />;
    }

    function simpleSearchForm() {
        return <WeeklyListsSimpleSearch state={filter} setter={setFilterModifier} />;
    }

    return (
        <Box>
            {simpleSearchForm()}
            {formActions()}
        </Box>
    );
};
